import React, { ComponentProps, forwardRef } from "react"
import styled from "styled-components"

import Input from "~/components/atoms/Input"
import Typography from "~/components/atoms/Typography"
import { SpacingSize } from "~/consts/style-mixins"

export type InputPropsWithoutSize = Omit<ComponentProps<typeof Input>, "size">

export type InputNumberProps = InputPropsWithoutSize & {
  unit?: string
  error?: boolean
  inputWidth?: string
}

export const InputNumber = forwardRef<HTMLInputElement, InputNumberProps>((props, ref) => {
  const { unit, error, inputWidth = "100%", type = "number", ...input } = props
  return (
    <StyledUnit>
      <Input {...input} ref={ref} type={type} size="Medium" isError={error} css={{ width: inputWidth }} />
      <StyledUnitText>
        <Typography type="Description">{unit}</Typography>
      </StyledUnitText>
    </StyledUnit>
  )
})

const StyledUnit = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`

const StyledUnitText = styled.div`
  margin-left: ${SpacingSize.S}px;
  white-space: nowrap;
`
